module.exports = __webpack_public_path__ + "img/icon-user-filled.57752531.svg";